export default "__VITE_ASSET__D9LosC0p__"